import WithSignatureModal from '../editor/signatures/withSignatureModal';
import { PreviewSignedSignatureBlock } from '../editor/GridDndEditor/Block/Signature';
import { type SectionsSignaturesType, SignatureStatus } from 'services/entities/SignatureTypes';

const PreviewSignatures = ({
  contentId,
  totalType,
  sectionId,
  sectionsSignatures,
  canvasWidth,
}: {
  contentId: string;
  totalType: string;
  sectionId: string;
  sectionsSignatures: SectionsSignaturesType;
  canvasWidth?: number;
}) => {
  const signatures = sectionsSignatures && sectionsSignatures[sectionId] ? sectionsSignatures[sectionId] : [];
  return (
    <>
      {signatures.map(({ signatureBoxId, properties, ...rest }) => {
        return rest.status === SignatureStatus.Signed ? (
          <PreviewSignedSignatureBlock
            signee={rest.signatureEvent}
            position={properties.position}
            signatureId={signatureBoxId}
            key={signatureBoxId}
            signedDate={rest.signatureEvent.signedDate}
            canvasWidth={canvasWidth}
          />
        ) : (
          <WithSignatureModal
            position={properties.position}
            dimensions={properties.dimensions}
            signatureId={signatureBoxId}
            key={signatureBoxId}
            assignedSignee={rest.assignedSignee}
            contentId={contentId}
            totalType={totalType}
          />
        );
      })}
    </>
  );
};

export default PreviewSignatures;
